import { type QueryHookOptions, useQuery } from "@apollo/client";
import { ReportQuery } from "../graphql/queries";
import type {
  ReportQueryType,
  ReportQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useReportQuery = (
  options?: QueryHookOptions<ReportQueryType, ReportQueryVariablesType>
) => {
  return useQuery<ReportQueryType, ReportQueryVariablesType>(
    ReportQuery,
    options
  );
};
